/* eslint-disable eqeqeq */
import React, { useState } from 'react'
import { Grid, Typography } from '@mui/material'
import Accordion from 'components/Common/Accordion/Accordion'
import RadioFormItem from 'components/Common/ElementInForm/RadioFormItem';
import InfoComplain from "assets/Image/ImgComplain/InfoComplain.png";
import wofkflow1 from "assets/Image/ImgComplain/wofkflow1.png";
import wofkflow2 from "assets/Image/ImgComplain/wofkflow2.png";

import PopUpCustom from 'components/PopupCustom/PopUpCustom';
import { BtnCancel, BtnCancelInModal, BtnCloseInModal } from 'components/Common/Button';

const CpnSolution = (props) => {
    const {
        form,
        Option,
        nStatusID,
        IsRoleDM,
        IsRoleVP,
        setsSolution,
        IsEmpRespon,
    } = props;

    const [IsOpenHelper, setIsOpenHelper] = useState(false)

    const onhandleOpenHelper = () => {
        setIsOpenHelper(!IsOpenHelper)
    }

    return (
        <>
            <Accordion header={"ข้อมูลแนวทางการแก้ไข (ข้อมูลใช้ภายใน)"} isShowHelper={true} onOpenHelper={onhandleOpenHelper}>
                <Grid container spacing={2} direction="row" justifyContent="start" alignItems="start" style={{ marginTop: '-35px' }}>
                    <Grid item xs={12} >
                        <RadioFormItem
                            name="sSolution"
                            label="แนวทางการแก้ไข"
                            required={true}
                            options={([3, 4, 19].includes(nStatusID) && (IsEmpRespon || (!IsRoleDM && !IsRoleVP))) ? Option.lstSolutionInprogress : (IsRoleDM ? Option.lstSolutionPart : (IsRoleVP ? Option.lstSolutionDepart : []))}
                            value={form.getValues("sSolution")}
                            row={true}
                            IsNewLine={false}
                            // disable={[3,4].includes(nStatusID)}
                            onChange={(e) => {
                                setsSolution(e)
                            }}
                        />
                    </Grid>
                </Grid>
            </Accordion>
            <PopUpCustom
                setIsOpen={setIsOpenHelper}
                IsOpen={IsOpenHelper}
                sMaxWidth={'md'}
                JsxDialogHeader={
                    <>
                        <Grid container direction="row" justifyContent="space-between" alignItems="center">
                            <Grid item>
                                <Typography>ข้อมูลเพิ่มเติม</Typography>
                            </Grid>
                            <Grid item>
                                <BtnCloseInModal txt={"ยกเลิก"} onClick={() => { onhandleOpenHelper() }} />
                            </Grid>
                        </Grid>
                    </>
                }
                JsxDialogContent={
                    <>
                        <Grid container spacing={1} direction="row" justifyContent="space-between" alignItems="center">
                            <Grid item xs={12}>
                                <img src={wofkflow1} alt={""} style={{ width: '100%' }} />
                            </Grid>
                            <Grid item xs={12}>
                                <img src={wofkflow2} alt={""} style={{ width: '100%' }} />
                            </Grid>
                        </Grid>
                    </>
                }
            />
        </>
    )
}

export default CpnSolution